export default "__VITE_ASSET__6343979f__"